import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Scrollbar, IconButton } from '@mssgme/ui';
import { DeprecatedCloseIcon } from '@mssgme/icons';

import styles from './QuickRepliesDialog.scss';

QuickRepliesDialog.propTypes = {
    title: PropTypes.node.isRequired,
    buttons: PropTypes.node,
    footer: PropTypes.node,
    children: PropTypes.node,
    onClose: PropTypes.func,
};

export default function QuickRepliesDialog({ onClose, title, buttons, children, footer }) {
    return (
        <div className={cn(styles.root)}>
            <header className={styles.header}>
                <div className={styles.headerBefore}>
                    <IconButton className={cn(styles.close)} onClick={onClose}>
                        <DeprecatedCloseIcon size={15} />
                    </IconButton>
                </div>
                <h4 className={styles.title}>{title}</h4>
                <div className={styles.headerAfter}>{buttons}</div>
            </header>
            <Scrollbar>
                <div className={styles.content}>{children}</div>
            </Scrollbar>
            {footer && <footer className={styles.footer}>{footer}</footer>}
        </div>
    );
}
